import { signal } from '@angular/core';
import { ListItem } from '../../models/ListItem';
import { AcsDropdownService } from './acs-dropdown.service';

export class AcsDropdownState {
  searchText = signal('');
  selectedValue: string = '';

  constructor(
    private _id: string,
    private _service: AcsDropdownService,
    private _itemsFn: () => ListItem[],
    private _placeholder: string
  ) {}

  isOpen(): boolean {
    return this._service.isOpen(this._id);
  }

  get displayText(): string {
    if (!this.selectedValue) return this._placeholder;
    const item: ListItem | undefined = this._itemsFn().find(l => l.value === this.selectedValue);
    return item ? item.text : this.selectedValue;
  }

  get filtered(): ListItem[] {
    const term: string = this.searchText();
    if (!term) return this._itemsFn();
    const lower: string = term.toLowerCase();
    return this._itemsFn().filter(l =>
      l.text.toLowerCase().includes(lower) || l.value.toLowerCase().includes(lower)
    );
  }

  toggle(): void {
    this._service.toggle(this._id);
    if (this.isOpen()) this.searchText.set('');
  }

  select(item: ListItem | null): string {
    this.selectedValue = item ? item.value : '';
    this._service.close();
    this.searchText.set('');
    return this.selectedValue;
  }

  close(): void {
    this._service.close();
  }
}
